/* eslint-disable no-undef */
// Need to use the React-specific entry point to import createApi
import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";

// Define a service using a base URL and expected endpoints
export const dashboardApi = createApi({
  reducerPath: "dashboardApi",
  baseQuery: fetchBaseQuery({
    baseUrl: process.env.REACT_APP_URL + "/api/dashboard/",
    prepareHeaders: (headers) => {
      const token = localStorage.getItem("token");
      const language = localStorage.getItem("language");
      // If we have a token set in state, let's assume that we should be passing it.
      if (token) {
        headers.set("x-access-token", `${token}`);
        headers.set("language", `${language}`);
      }
      return headers;
    },
  }),
  endpoints: (builder) => ({
    getNumberDiplomasByadmin: builder.mutation({
      query: (data) => ({
        body: data,
        method: "GET",
        url: "getNumberDiplomasByadmin",
      }),
    }),
    getNumberDiplomasByResp: builder.mutation({
      query: (data) => ({
        body: data,
        method: "GET",
        url: "getNumberOfDiplomasByUniversity",
      }),
    }),
    getDiplomasBysex: builder.mutation({
      query: (data) => ({
        body: data,
        method: "GET",
        url: "getDiplomasBysex",
      }),
    }),
    getDiplomasBysexByUniOrResp: builder.mutation({
      query: (data) => ({
        body: data,
        method: "GET",
        url: "getDiplomasBysexByUniOrResp",
      }),
    }),
    getNbrOfVistis: builder.mutation({
      query: (data) => ({
        body: data,
        method: "GET",
        url: "getNbrOfVistis",
      }),
    }),
    getNbrOfVistisByMonth: builder.mutation({
      query: (data) => ({
        body: data,
        method: "GET",
        url: "getNbrOfVistisByMonth",
      }),
    }),
    getNbrOfVistisByMonthAndUniversity: builder.mutation({
      query: (data) => ({
        body: data,
        method: "GET",
        url: "getNbrOfVistisByMonthAndUniversity",
      }),
    }),
    getNbrOfVistisByUniversity: builder.mutation({
      query: (data) => ({
        body: data,
        method: "GET",
        url: "getNbrOfVistisByUniversity",
      }),
    }),
    getNbStudents: builder.mutation({
      query: (data) => ({
        body: data,
        method: "GET",
        url: "getNbStudent",
      }),
    }),
    getNbStudentbyResp: builder.mutation({
      query: (data) => ({
        body: data,
        method: "GET",
        url: "getNbStudentbyResp",
      }),
    }),
    getDailyVisits: builder.mutation({
      query: (data) => ({
        body: data,
        method: "GET",
        url: "getDailyVisits",
      }),
    }),
    getDailyVisitsByUniversity: builder.mutation({
      query: (data) => ({
        body: data,
        method: "GET",
        url: "getDailyVisitsByUniversity",
      }),
    }),
    getNumberOfUniversitiesByCountry: builder.mutation({
      query: (data) => ({
        body: data,
        method: "GET",
        url: "getNumberOfUniversitiesByCountry",
      }),
    }),
  }),
});

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const {
  useGetNumberDiplomasByadminMutation,
  useGetNumberDiplomasByRespMutation,
  useGetDiplomasBysexMutation,
  useGetDiplomasBysexByUniOrRespMutation,
  useGetNbrOfVistisMutation,
  useGetNbrOfVistisByMonthMutation,
  useGetNbrOfVistisByMonthAndUniversityMutation,
  useGetNbrOfVistisByUniversityMutation,
  useGetNbStudentbyRespMutation,
  useGetNbStudentsMutation,
  useGetDailyVisitsMutation,
  useGetDailyVisitsByUniversityMutation,
  useGetNumberOfUniversitiesByCountryMutation,
} = dashboardApi;
